<template>
  <div v-if="isShow.isPTShow" class="pg2">
    <div class="myhaibao">
      <img :src="haibaoUrl" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTwo',
  props: {
    isShow: Object,
    haibao:String
  },
  data() {
    return {
      haibaoUrl:""
    }
  },
  methods: {
    //
  },
  watch:{
    "haibao":function(){
      this.haibaoUrl=this.haibao
    }
  }
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg2 {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
}

.myhaibao{
  img{
    width: 100%;
  }
}

@media only screen and (device-width: 414px) and (device-height: 736px) {}
</style>



// WEBPACK FOOTER //
// src/pages/page-two/pageTwo.vue